import React, { useEffect, useState } from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import Loader from "../../components/shared/Loader";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import { useDropzone } from "react-dropzone";
import { set } from "react-hook-form";

const ServiceShow = ({ match }) => {
	const {
		params: { serviceID },
	} = match;

	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [pageContent, setPageContent] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [featureTitle, setFeatureTitle] = useState("");
	const [features, setFeatures] = useState([]);
	const [files, setFiles] = useState([]);
	const [catalog, setCatalog] = useState([]);
	const [selectedCatalog, setSelectedCatalog] = useState([]);
	const [imageArray, setImageArray] = useState([]);
	const [mainPicture, setMainPicture] = useState(null);
	const [singleCatalog, setSingleCatalog] = useState(null);
	const [singleCatalogName, setSingleCatalogName] = useState("");
	const [descriptionEn, setDescriptionEn] = useState("");
	const [pageContentEn, setPageContentEn] = useState("");
	const [featureTitleEn, setFeatureTitleEn] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [isImageChanged, setIsImageChanged] = useState(false);
	const [servicesCategories, setServicesCategories] = useState([]);
	const [targetServiceCategory, setTargetServiceCategory] = useState("");

	const dispatch = useDispatch();

	let editor = null;

	useEffect(() => {
		onStart();
	}, []);

	useEffect(
		() => () => {
			files.forEach(file => URL.revokeObjectURL(file.preview));
		},
		[files]
	);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل  الخدمة",
				breadcrumb: "الخدمات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		const fetchServicesCategories = async () => {
			axios
				.get(`${process.env.REACT_APP_API_URL}/serviceCategories`, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				})
				.then(function (response) {
					setServicesCategories(response.data.data);
					setLoading(false);
				})
				.catch(function (error) {
					toast.error("خطأ، برجاء المحاولة لاحقا!");
					setLoading(false);
				});
		};
		fetchServicesCategories();

		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/${serviceID}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setLoading(false);
				setTitle(response.data.data.data.title?.ar);
				setTitleEn(response.data.data.data.title?.en);
				setDescription(response.data.data.data.description?.ar);
				setDescriptionEn(response.data.data.data.description?.en);
				setPageContent(response.data.data.data.page_content?.ar ?? "");
				setPageContentEn(response.data.data.data.page_content?.en ?? "");
				setPicture(response.data.data.data.icon);
				setMainPicture(response.data.data.data.image);
				setSingleCatalog(response.data.data.data.catalog);
				setFeatures(response.data.data.data.features ?? []);
				setSingleCatalogName(response.data.data.data.catalogName ?? "");

				setTargetServiceCategory(response.data.data.data.service_category_id);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	// const handlePicture = e => {
	// 	setLoading(true);
	// 	const fileInput = document.querySelector("#picture");
	// 	setPicture(URL.createObjectURL(fileInput.files[0]));
	// 	const data = new FormData();
	// 	data.append("file", fileInput.files[0]);
	// 	axios
	// 		.post(`${process.env.REACT_APP_MAIN_URL}/api/upload`, data, {
	// 			headers: {
	// 				Authorization: `Bearer ${cookie.get("token")}`,
	// 				Accept: "application/json",
	// 				"Content-Type": "multipart/form-data",
	// 			},
	// 		})
	// 		.then(response => {
	// 			setPicture(response.data.data.name);
	// 			setLoading(false);
	// 			toast.success("تم رفع الصورة بنجاح!");
	// 		})
	// 		.catch(error => {
	// 			toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
	// 			setLoading(false);
	// 		});
	// };
	const handlePicture = id => {
		const fileInput = document.querySelector(id);

		if (!fileInput) {
			console.error(`Element with ID "${id}" not found.`);
			return; // Exit the function early if the element isn't found
		}

		if (fileInput.files && fileInput.files[0]) {
			// Check if files exist and are not empty
			if (id === "#mainPicture") {
				setMainPicture(URL.createObjectURL(fileInput.files[0]));
			} else if (id === "#singleCatalog") {
				setSingleCatalog(URL.createObjectURL(fileInput.files[0]));
				setSingleCatalogName(fileInput.files[0].name);
			} else {
				setPicture(URL.createObjectURL(fileInput.files[0]));
			}
		} else {
			console.warn(`No file selected for ${id}`);
			// Handle the case where no file is selected (optional)
		}
	};

	const pushToInformation = e => {
		e.preventDefault();
		if (featureTitle === "") {
			toast.error("برجاء تعبئة الحقول المطلوبة!");
			return;
		}
		const data = { ar: featureTitle, en: featureTitleEn };
		setFeatures(prev => {
			return [...prev, data];
		});
		setFeatureTitle("");
		setFeatureTitleEn("");
	};

	const handleDeleteFeature = (event, information) => {
		event.preventDefault();
		const arr = features.filter(function (item) {
			return item.ar !== information.ar || item.en !== information.en;
		});
		setFeatures(arr);
	};

	const handleImageUpload = async (e, id) => {
		if (id === "#mainPicture" && mainPicture === null) {
			toast.error("برجاء إختيار صورة اولا");
			return;
		}
		if (id === "#singleCatalog" && singleCatalog === null) {
			toast.error("برجاء إختيار الملف  اولا");
			return;
		}
		if (id === "#picture" && picture === null) {
			toast.error("برجاء إختيار صورة اولا");
			return;
		}
		e.preventDefault();
		setLoading(true);
		const fileInput = document.querySelector(id);
		const formData = new FormData();
		formData.append("file", fileInput.files[0]);
		await axios
			.post(`${process.env.REACT_APP_API_URL}/upload`, formData, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(function (responseImage) {
				if (id === "#mainPicture") {
					setMainPicture(responseImage.data.data.name);
					setLoading(false);
					setIsImageChanged(true);
					toast.success("تم رفع الصورة بنجاح!");
				} else if (id === "#singleCatalog") {
					setSingleCatalog(responseImage.data.data.name);
					setLoading(false);
					setIsImageChanged(true);
					setSingleCatalogName(formData.get("file").name);
					toast.success("تم رفع الملف بنجاح!");
				} else if (id === "#picture") {
					setPicture(responseImage.data.data.name);
					setLoading(false);
					setIsImageChanged(true);
					toast.success("تم رفع الصورة بنجاح!");
				}
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});

		setLoading(false);
		toast.success("تم رفع الصور بنجاح!");
	};

	const deleteCatalog = (event, catalog) => {
		event.preventDefault();
		setSingleCatalog(null);
		setSingleCatalogName("");
		setCatalog([]);
		document.getElementById("singleCatalog").value = null;
	};
	const handleSubmit = e => {
		e.preventDefault();
		if (!title || !titleEn) {
			toast.error("برجاء أدخال العنوان");
			return;
		}
		if (!pageContent) {
			toast.error("برجاء أدخال المحتوى");
			return;
		}
		if (!description) {
			toast.error("برجاء أدخال الوصف");
			return;
		}
		if (!picture) {
			toast.error("برجاء أدخال الصورة");
			return;
		}
		if (!mainPicture) {
			toast.error("برجاء أدخال الصورة الرئيسية");
			return;
		}
		setLoading(true);
		const data = {
			title: {
				ar: title,
				en: titleEn,
			},
			description: {
				ar: description,
				en: descriptionEn,
			},
			icon: picture,
			page_content: {
				ar: pageContent,
				en: pageContentEn,
			},
			features: features,
			image: mainPicture,
			catalog: singleCatalog,
			catalogName: singleCatalogName,
			service_category_id: targetServiceCategory,
		};
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/posts/${serviceID}`,
				{
					category_id: 3,
					admin_id: auth.id,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				toast.success("تم تحديث الخدمة بنجاح!");
				history.push("/services/index");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="title">العنوان</label>
										<input
											type="text"
											id="title"
											required
											value={title}
											onChange={e => setTitle(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="titleEn">العنوان الانجليزي</label>
										<input
											type="text"
											id="titleEn"
											required
											dir="ltr"
											value={titleEn}
											onChange={e => setTitleEn(e.target.value)}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="description">الوصف</label>
										<input
											type="text"
											id="description"
											required
											value={description}
											onChange={e => setDescription(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="descriptionEn"> الوصف الانجليزي</label>
										<input
											type="text"
											id="descriptionEn"
											required
											dir="ltr"
											value={descriptionEn}
											onChange={e => setDescriptionEn(e.target.value)}
										/>
									</div>
								</div>
								<div className="row">
									<div className="form-item  col-md-6">
										<label htmlFor="description">تصنيف الخدمة</label>
										<select
											onChange={e => setTargetServiceCategory(e.target.value)}
											value={targetServiceCategory}
										>
											{servicesCategories?.map((item, index) => (
												<option value={item?.id} key={index}>
													{item?.name?.ar}
												</option>
											))}
										</select>
									</div>
								</div>
								<div className="form-item">
									<label htmlFor="pageContent">النص</label>
									<CKEditor
										data={pageContent}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setPageContent(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "rtl",
											language: "ar",
											extraPlugins: [MyCustomUploadAdapterPlugin],
										}}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageContent">النص الانجليزي</label>
									<CKEditor
										data={pageContentEn}
										onReady={editor => {
											editor.ui
												.getEditableElement()
												.parentElement.insertBefore(
													editor.ui.view.toolbar.element,
													editor.ui.getEditableElement()
												);
											editor = editor;
										}}
										onError={({ willEditorRestart }) => {
											if (willEditorRestart) {
												editor.ui.view.toolbar.element.remove();
											}
										}}
										onChange={(event, editor) => {
											const data = editor.getData();
											setPageContentEn(data);
										}}
										editor={DecoupledEditor}
										config={{
											contentsLangDirection: "ltr",
											language: "en",
											extraPlugins: [MyCustomUploadAdapterPlugin],
										}}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="mainPicture">الصوره</label>
									<input
										type="file"
										onChange={e => handleImageUpload(e, "#mainPicture")}
										id="mainPicture"
									/>
									{mainPicture && (
										<div className="img-holder">
											<img
												src={`${process.env.REACT_APP_MAIN_URL}${mainPicture}`}
												alt="avatar"
												className="imagePreview"
											/>
										</div>
									)}
								</div>

								<div className="form-item">
									<label htmlFor="singleCatalog">الكتالوج</label>
									<input
										type="file"
										onChange={e => handleImageUpload(e, "#singleCatalog")}
										id="singleCatalog"
									/>
									{singleCatalog && (
										<div className="img-holder d-flex justify-content-between ">
											<div className="catalog  my-3">
												<i className="fas fa-file-alt" /> {singleCatalogName}
											</div>
											<button onClick={e => deleteCatalog(e)}>
												<i className="fas fa-trash" />
											</button>
										</div>
									)}
								</div>
								<br />
								<hr />
								<div className="row">
									<div className="form-item col-md-6">
										<label htmlFor="question">عنوان الميزة</label>
										<input
											type="text"
											id="question"
											value={featureTitle}
											onChange={e => setFeatureTitle(e.target.value)}
										/>
									</div>
									<div className="form-item col-md-6">
										<label htmlFor="questionen"> (الانجليزي)عنوان الميزة</label>
										<input
											type="text"
											id="questionen"
											dir="ltr"
											value={featureTitleEn}
											onChange={e => setFeatureTitleEn(e.target.value)}
										/>
									</div>
								</div>
								<div className="form-item" />
								<button className="bt bt-success" onClick={pushToInformation}>
									اضافة الميزة
								</button>
								<div className="form-item" style={{ marginTop: "40px" }}>
									<ul className="list-unstyled pointList">
										{features.map(feature => (
											<li
												key={feature.title}
												className="d-flex justify-content-between"
											>
												<button onClick={e => handleDeleteFeature(e, feature)}>
													<i className="fas fa-trash" />
												</button>
												<div className="point row  w-100">
													<span className="col-md-6">عربي : {feature.ar}</span>{" "}
													<span className="col-md-6">
														{" "}
														الانجليزي : {feature.en}
													</span>
												</div>
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input
										type="file"
										onChange={e => handleImageUpload(e, "#picture")}
										id="picture"
									/>
									{picture && (
										<div className="img-holder">
											<img
												src={`${process.env.REACT_APP_MAIN_URL}${picture}`}
												alt="avatar"
												className="imagePreview"
											/>
										</div>
									)}
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

function MyCustomUploadAdapterPlugin(editor) {
	editor.plugins.get("FileRepository").createUploadAdapter = loader => {
		return new MyUploadAdapter(loader);
	};
}

class MyUploadAdapter {
	constructor(props) {
		this.loader = props;
		this.url = `${process.env.REACT_APP_API_URL}/upload`;
	}

	upload() {
		return new Promise((resolve, reject) => {
			this._initRequest();
			this._initListeners(resolve, reject);
			this._sendRequest();
		});
	}

	abort() {
		if (this.xhr) {
			this.xhr.abort();
		}
	}

	_initRequest() {
		const xhr = (this.xhr = new XMLHttpRequest());

		xhr.open("POST", this.url, true);
		xhr.responseType = "json";
		xhr.setRequestHeader("Authorization", `Bearer ${cookie.get("token")}`);
	}

	_initListeners(resolve, reject) {
		const xhr = this.xhr;
		const loader = this.loader;
		const genericErrorText = "Couldn't upload file:" + ` ${loader.file.name}.`;

		xhr.addEventListener("error", () => reject(genericErrorText));
		xhr.addEventListener("abort", () => reject());
		xhr.addEventListener("load", () => {
			const response = xhr.response;
			if (!response || response.error) {
				return reject(
					response && response.error ? response.error.message : genericErrorText
				);
			}
			resolve({
				default: response.data.filePath,
			});
		});

		if (xhr.upload) {
			xhr.upload.addEventListener("progress", evt => {
				if (evt.lengthComputable) {
					loader.uploadTotal = evt.total;
					loader.uploaded = evt.loaded;
				}
			});
		}
	}

	_sendRequest() {
		const data = new FormData();
		this.loader.file.then(result => {
			data.append("file", result);
			this.xhr.send(data);
		});
	}
}

export default ServiceShow;
